/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ReserviertRouteImport } from './routes/reserviert'
import { Route as LoginRouteImport } from './routes/login'
import { Route as KanbanRouteImport } from './routes/kanban'
import { Route as EinstellungenRouteImport } from './routes/einstellungen'
import { Route as ArchivRouteImport } from './routes/archiv'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DruckenZeichenRouteImport } from './routes/drucken.$zeichen'
import { Route as BestellungenBestellnrRouteImport } from './routes/bestellungen/$bestellnr'
import { Route as BestellungenBestellnrLieferscheinRouteImport } from './routes/bestellungen/$bestellnr_.lieferschein'
import { Route as BestellungenBestellnrDruckRouteImport } from './routes/bestellungen/$bestellnr_.druck'

const ReserviertRoute = ReserviertRouteImport.update({
  id: '/reserviert',
  path: '/reserviert',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const KanbanRoute = KanbanRouteImport.update({
  id: '/kanban',
  path: '/kanban',
  getParentRoute: () => rootRouteImport,
} as any)
const EinstellungenRoute = EinstellungenRouteImport.update({
  id: '/einstellungen',
  path: '/einstellungen',
  getParentRoute: () => rootRouteImport,
} as any)
const ArchivRoute = ArchivRouteImport.update({
  id: '/archiv',
  path: '/archiv',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DruckenZeichenRoute = DruckenZeichenRouteImport.update({
  id: '/drucken/$zeichen',
  path: '/drucken/$zeichen',
  getParentRoute: () => rootRouteImport,
} as any)
const BestellungenBestellnrRoute = BestellungenBestellnrRouteImport.update({
  id: '/bestellungen/$bestellnr',
  path: '/bestellungen/$bestellnr',
  getParentRoute: () => rootRouteImport,
} as any)
const BestellungenBestellnrLieferscheinRoute =
  BestellungenBestellnrLieferscheinRouteImport.update({
    id: '/bestellungen/$bestellnr_/lieferschein',
    path: '/bestellungen/$bestellnr/lieferschein',
    getParentRoute: () => rootRouteImport,
  } as any)
const BestellungenBestellnrDruckRoute =
  BestellungenBestellnrDruckRouteImport.update({
    id: '/bestellungen/$bestellnr_/druck',
    path: '/bestellungen/$bestellnr/druck',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/archiv': typeof ArchivRoute
  '/einstellungen': typeof EinstellungenRoute
  '/kanban': typeof KanbanRoute
  '/login': typeof LoginRoute
  '/reserviert': typeof ReserviertRoute
  '/bestellungen/$bestellnr': typeof BestellungenBestellnrRoute
  '/drucken/$zeichen': typeof DruckenZeichenRoute
  '/bestellungen/$bestellnr/druck': typeof BestellungenBestellnrDruckRoute
  '/bestellungen/$bestellnr/lieferschein': typeof BestellungenBestellnrLieferscheinRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/archiv': typeof ArchivRoute
  '/einstellungen': typeof EinstellungenRoute
  '/kanban': typeof KanbanRoute
  '/login': typeof LoginRoute
  '/reserviert': typeof ReserviertRoute
  '/bestellungen/$bestellnr': typeof BestellungenBestellnrRoute
  '/drucken/$zeichen': typeof DruckenZeichenRoute
  '/bestellungen/$bestellnr/druck': typeof BestellungenBestellnrDruckRoute
  '/bestellungen/$bestellnr/lieferschein': typeof BestellungenBestellnrLieferscheinRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/archiv': typeof ArchivRoute
  '/einstellungen': typeof EinstellungenRoute
  '/kanban': typeof KanbanRoute
  '/login': typeof LoginRoute
  '/reserviert': typeof ReserviertRoute
  '/bestellungen/$bestellnr': typeof BestellungenBestellnrRoute
  '/drucken/$zeichen': typeof DruckenZeichenRoute
  '/bestellungen/$bestellnr_/druck': typeof BestellungenBestellnrDruckRoute
  '/bestellungen/$bestellnr_/lieferschein': typeof BestellungenBestellnrLieferscheinRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/archiv'
    | '/einstellungen'
    | '/kanban'
    | '/login'
    | '/reserviert'
    | '/bestellungen/$bestellnr'
    | '/drucken/$zeichen'
    | '/bestellungen/$bestellnr/druck'
    | '/bestellungen/$bestellnr/lieferschein'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/archiv'
    | '/einstellungen'
    | '/kanban'
    | '/login'
    | '/reserviert'
    | '/bestellungen/$bestellnr'
    | '/drucken/$zeichen'
    | '/bestellungen/$bestellnr/druck'
    | '/bestellungen/$bestellnr/lieferschein'
  id:
    | '__root__'
    | '/'
    | '/archiv'
    | '/einstellungen'
    | '/kanban'
    | '/login'
    | '/reserviert'
    | '/bestellungen/$bestellnr'
    | '/drucken/$zeichen'
    | '/bestellungen/$bestellnr_/druck'
    | '/bestellungen/$bestellnr_/lieferschein'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ArchivRoute: typeof ArchivRoute
  EinstellungenRoute: typeof EinstellungenRoute
  KanbanRoute: typeof KanbanRoute
  LoginRoute: typeof LoginRoute
  ReserviertRoute: typeof ReserviertRoute
  BestellungenBestellnrRoute: typeof BestellungenBestellnrRoute
  DruckenZeichenRoute: typeof DruckenZeichenRoute
  BestellungenBestellnrDruckRoute: typeof BestellungenBestellnrDruckRoute
  BestellungenBestellnrLieferscheinRoute: typeof BestellungenBestellnrLieferscheinRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reserviert': {
      id: '/reserviert'
      path: '/reserviert'
      fullPath: '/reserviert'
      preLoaderRoute: typeof ReserviertRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kanban': {
      id: '/kanban'
      path: '/kanban'
      fullPath: '/kanban'
      preLoaderRoute: typeof KanbanRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/einstellungen': {
      id: '/einstellungen'
      path: '/einstellungen'
      fullPath: '/einstellungen'
      preLoaderRoute: typeof EinstellungenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/archiv': {
      id: '/archiv'
      path: '/archiv'
      fullPath: '/archiv'
      preLoaderRoute: typeof ArchivRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/drucken/$zeichen': {
      id: '/drucken/$zeichen'
      path: '/drucken/$zeichen'
      fullPath: '/drucken/$zeichen'
      preLoaderRoute: typeof DruckenZeichenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bestellungen/$bestellnr': {
      id: '/bestellungen/$bestellnr'
      path: '/bestellungen/$bestellnr'
      fullPath: '/bestellungen/$bestellnr'
      preLoaderRoute: typeof BestellungenBestellnrRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bestellungen/$bestellnr_/lieferschein': {
      id: '/bestellungen/$bestellnr_/lieferschein'
      path: '/bestellungen/$bestellnr/lieferschein'
      fullPath: '/bestellungen/$bestellnr/lieferschein'
      preLoaderRoute: typeof BestellungenBestellnrLieferscheinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bestellungen/$bestellnr_/druck': {
      id: '/bestellungen/$bestellnr_/druck'
      path: '/bestellungen/$bestellnr/druck'
      fullPath: '/bestellungen/$bestellnr/druck'
      preLoaderRoute: typeof BestellungenBestellnrDruckRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ArchivRoute: ArchivRoute,
  EinstellungenRoute: EinstellungenRoute,
  KanbanRoute: KanbanRoute,
  LoginRoute: LoginRoute,
  ReserviertRoute: ReserviertRoute,
  BestellungenBestellnrRoute: BestellungenBestellnrRoute,
  DruckenZeichenRoute: DruckenZeichenRoute,
  BestellungenBestellnrDruckRoute: BestellungenBestellnrDruckRoute,
  BestellungenBestellnrLieferscheinRoute:
    BestellungenBestellnrLieferscheinRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
